"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _style = _interopRequireDefault(require("../style"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject());

var Main =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Main, _Component);

  function Main() {
    (0, _classCallCheck2["default"])(this, Main);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).apply(this, arguments));
  }

  (0, _createClass2["default"])(Main, [{
    key: "render",
    value: function render() {
      var styles = this.compileStyled(_style["default"]);
      return _react["default"].createElement(Root, {
        styles: styles.root
      }, this.props.children);
    }
  }]);
  return Main;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Main, "propTypes", {
  rightTop: _propTypes["default"].bool,
  rightBottom: _propTypes["default"].bool,
  leftTop: _propTypes["default"].bool,
  leftBottom: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default 0 6px 10px 0 ${palette.elShadow}, 0 4px 10px 0 ${palette.elShadow}
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default 2px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    zIndex: _propTypes["default"].number,

    /**
     * @default palette.tsNormal
     */
    itemFontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    itemLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tFilled
     */
    itemColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    itemBackground: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    itemPaddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    itemPaddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 2 + 'px'
     */
    itemPaddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 2 + 'px'
     */
    itemPaddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.elLightest
     */
    hoverItemBackground: _propTypes["default"].string,

    /**
     * @default pointer
     */
    hoverItemCursor: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "defaultProps", {
  rightTop: false,
  rightBottom: false,
  leftTop: false,
  leftBottom: false
});
(0, _defineProperty2["default"])(Main, "displayName", 'Menu');
var _default = Main;
exports["default"] = _default;